import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlertOPEEnum} from "./AlertOPEEnum";
import {DateIntervalDTO} from "../diagnostic/GetDiagnosticEventsCB";

/**
 * O Inner Class
 */
class O {
  events: AlarmEventDTO[];

  constructor() {
    this.events = [];
  }
}

class AlarmEventDTO {
  ts!: Date;
  alarmStatusValue!: number;
  message!: string;
}


class I {

  partitionId!: number;
  metricInstanceAlertId!: number;
  lastEvents: boolean = false;
  lastEventsNumber?: number;
  dateInterval?: DateIntervalDTO;

}


export class GetMetricInstanceAlertEventsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AlertOPEEnum.GetMetricInstanceAlertEvents);
    this.i = new I();
    this.o = new O();
  }
}
